import Link from "next/link";
import { cn } from "@/app/lib/utils/cn";
import type { ReactNode } from "react";

type CTAVariant = "gold" | "pink" | "purple" | "brand";
type CTASize = "sm" | "md" | "lg";
type CTARounded = "full" | "xl" | "lg" | "md";

interface CTAButtonProps {
  href: string;
  children: ReactNode;
  variant?: CTAVariant;
  size?: CTASize;
  rounded?: CTARounded;
  newTab?: boolean;
  className?: string;
}

const variantStyles: Record<CTAVariant, string> = {
  gold: "bg-(--gold) text-(--text-on-gold) focus:ring-(--gold)",
  pink: "bg-(--brand) text-(--text-on-pink) focus:ring-(--brand)",
  purple: "bg-(--purple) text-(--text-on-purple) focus:ring-(--purple)",
  brand: "bg-(--brand) text-(--text-on-brand) focus:ring-(--brand)",
};

const sizeStyles: Record<CTASize, string> = {
  sm: "px-4 py-2 text-sm",
  md: "px-6 py-3 text-base md:text-lg",
  lg: "px-8 py-4 text-xl md:text-2xl xl:text-3xl",
};

const roundedStyles: Record<CTARounded, string> = {
  full: "rounded-full",
  xl: "rounded-xl",
  lg: "rounded-lg",
  md: "rounded-md",
};

export default function CTAButton({
  href,
  children,
  variant = "gold",
  size = "md",
  rounded = "full",
  newTab = false,
  className,
}: CTAButtonProps) {
  return (
    <Link
      href={href}
      target={newTab ? "_blank" : "_self"}
      rel={newTab ? "noopener noreferrer" : undefined}
      className={cn(
        "btn-hover inline-block font-['Font-Bold'] hover:brightness-110 focus:outline-none focus:ring-2 focus:ring-offset-2 text-center",
        variantStyles[variant],
        sizeStyles[size],
        roundedStyles[rounded],
        className
      )}
    >
      {children}
    </Link>
  );
}
